// services/freightRateService.js
import axios from "axios";
import { BASE_API_CONFIG } from "../../util/Api";

export const getFreightRates = async () => {
  const response = await axios.get(`${BASE_API_CONFIG.baseURL}/updates-freight-rates`);
  return response.data;
};